import { NavLink } from "react-router-dom";
import { useAtom } from "jotai";
import { sideBarAtom } from "../../atoms/side-bar-atom";
import { classNames } from "primereact/utils";
import { Tooltip } from "primereact/tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface SideBarElementProps {
  to: string;
  label: string;
  icon: any;
}

export function SideBarElementDesktop({
  to,
  label,
  icon,
}: SideBarElementProps) {
  const [sidebarState] = useAtom(sideBarAtom);
  return (
    <>
      <Tooltip
        className={sidebarState.expanded ? "hidden" : ""}
        target=".tooltip"
      />
      <li
        className={classNames(
          "flex align-center",
          sidebarState.expanded ? "" : "text-center justify-center"
        )}
      >
        <NavLink
          data-pr-tooltip={label}
          to={to}
          className={({ isActive }) =>
            classNames(
              "py-3 px-5 text-center text-white tooltip no-underline text-sm inline-flex align-items-center flex-nowrap",
              isActive ? "font-bold text-primary" : "",
              sidebarState.expanded
                ? "hover:text-gray-100"
                : "hover:text-gray-200"
            )
          }
        >
          <i className={classNames(sidebarState.expanded ? "pr-4" : "")}>
            <FontAwesomeIcon icon={icon} className="text-xl" />
          </i>
          <div
            className={classNames(
              "transition-duration-150 whitespace-nowrap",
              sidebarState.expanded ? "" : "hidden"
            )}
          >
            {label}
          </div>
        </NavLink>
      </li>
    </>
  );
}
